import React from "react";
import { CloseIcon, WarningIcon } from "./aiWriteIcons";
import styles from "./AiWrite.module.scss";

const WarningStep = ({ onConfirm, onClose }) => {
    return (
        <div className={styles.warningStep}>
            <button className={styles.closeBtn} onClick={onClose}>
                <CloseIcon />
            </button>

            <div className={styles.warningIcon}>
                <WarningIcon />
            </div>

            <h2 className={styles.warningTitle}>작성중인 내용이 삭제됩니다!</h2>
            <p className={styles.warningDesc}>
                AI 글쓰기를 적용하면 현재 입력된 내용이
                <br />모두 사라집니다.
            </p>
            <p className={styles.warningNotice}>
                내용 유지가 필요하다면
                <br />미리 복사해두세요!
            </p>

            <button className={styles.warningConfirmBtn} onClick={onConfirm}>
                확인했습니다!
            </button>
        </div>
    );
};

export default WarningStep;
